import ContactButtons from "@/app/__to_be_integrated/_____components/contact-buttons/ContactButtons";
import { ContactProvider } from "@/app/contexts/contact-context";
import TeamMemberView from "./TeamMemberView";
import { RelatedInfo } from "@/app/lib/generated/graphql-types";

export default function ContactView({ info }: { info: RelatedInfo }) {
    const {
        teamMember,
        showGeneralContact
    } = info;

    if (teamMember) {
        return <TeamMemberView teamMember={teamMember} />;
    } else if (showGeneralContact) {
        return (
            <ContactProvider>
                <ContactButtons />
            </ContactProvider>
        )
    } else {
        return null;
    }
}